module.exports = __webpack_public_path__ + "img/ic_instagram.923e0b56.png";